import React, { useState, useEffect } from 'react';
import { forwardRef } from 'react';
import Grid from '@material-ui/core/Grid';
import MaterialTable from '@material-table/core';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ExportCsv } from '@material-table/exporters';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export const AssetsSensorsList = () => {
  // Use this url for testing
  // username: uniper+report+user password: E7yzc3q8zEw9nDym
  // http://localhost:3000/assets_sensors_list?organization=153&location=199&t=4677042a-549f-487a-bba4-9fe0e6b50913

  const [searchParams] = useSearchParams();
  const orgid = searchParams.get('organization');
  const locid = searchParams.get('location');
  const { token } = useAuth();
  const all_assets_url = `https://eu-api.empathicbuilding.com/v1/organizations/${orgid}/locations/${locid}/assets`;
  const all_sensors_url = `https://eu-api.empathicbuilding.com/v1/organizations/${orgid}/locations/${locid}/sensors`;

  const api = axios.create({
    baseURL: 'https://eu-api.empathicbuilding.com/v1',
    headers: { Authorization: `Bearer ${token}` },
  });
  const columns = [
    { title: 'asset_id', field: 'asset_id' },
    { title: 'parent_id', field: 'parent_id' },
    { title: 'asset_type', field: 'asset_type' },
    { title: 'asset_name', field: 'asset_name' },
    { title: 'sensor_id', field: 'sensor_id' },
    { title: 'sensor_type', field: 'sensor_type' },
    { title: 'vendor', field: 'vendor' },
    { title: 'vendor_id', field: 'vendor_id' },
  ];
  const [data, setData] = useState([]);
  const [iserror] = useState(false);
  const [errorMessages] = useState([]);
  let final_list = [];

  useEffect(() => {
    let sensor = [];
    const fetchData = async () => {
      const assets = await api.get(all_assets_url);
      const sensors = await api.get(all_sensors_url);

      assets.data.forEach((asset) => {
        if (asset.hasOwnProperty('data_providers')) {
          asset['data_providers'].forEach((data_provider) => {
            sensor = sensors.data.filter(function (value) {
              return value.id === data_provider;
            });
            if (sensor[0] !== undefined) {
              final_list.push({
                asset_id: asset['id'],
                parent_id: asset['parent_id'],
                asset_type: asset['type'],
                asset_name: asset['name'],
                sensor_id: sensor[0]['id'],
                sensor_type: sensor[0]['type'],
                vendor: sensor[0]['vendor'],
                vendor_id: sensor[0]['vendor_id'],
              });
            }
          });
        }
      });
      setData(final_list);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#4caf50',
      },
      secondary: {
        main: '#ff9100',
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <div className="App">
        <Grid container spacing={1}>
          <Grid item xs={3}></Grid>
          <Grid item xs={6}>
            <div>
              {iserror && (
                <Alert severity="error">
                  {errorMessages.map((msg, i) => {
                    return <div key={i}>{msg}</div>;
                  })}
                </Alert>
              )}
            </div>

            <h1>Assets and sensors list</h1>
            <MaterialTable
              title="Assets and sensors list"
              columns={columns}
              data={data}
              icons={tableIcons}
              options={{
                exportAllData: true,
                pageSize: 10,
                exportMenu: [
                  {
                    label: 'Export CSV',
                    exportFunc: (cols, datas) =>
                      ExportCsv(cols, datas, 'Assets_sensors_list'),
                  },
                ],
              }}
            />
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
      </div>
    </MuiThemeProvider>
  );
};
